;(function () {
  'use strict'

  angular.module('contrast.stats').directive('statsToggle', statsToggle)

  function statsToggle(
    $,
    canvasUtilsService,
    GoogleAnalyticsService,
    csAnalyticsEventsService
  ) {
    'ngInject'

    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'views/stats-toggle.html',
      scope: {
        open: '=',
        openedText: '@',
        closedText: '@',
        onOpen: '='
      },
      link: function ($scope, elem, attrs) {
        $scope.relative = !angular.isUndefined(attrs.relative)
        $scope.openedText = $scope.openedText || 'Close Stats'
        $scope.closedText = $scope.closedText || 'Open Stats'
        $scope.toggleStats = function () {
          $scope.open = !$scope.open

          if ($scope.open) {
            var event = csAnalyticsEventsService.getEvent('libraries.stats')
            GoogleAnalyticsService.sendEvent(event)
          }

          if ($scope.onOpen !== undefined) {
            $scope.onOpen()
          }
        }

        var openedTextWidth = canvasUtilsService.getTextWidth(
          $scope.openedText,
          '14px "Lato"'
        )
        var closedTextWidth = canvasUtilsService.getTextWidth(
          $scope.closedText,
          '14px "Lato"'
        )
        var largestWidth = Math.ceil(
          openedTextWidth > closedTextWidth ? openedTextWidth : closedTextWidth
        )
        $(elem[0]).width(largestWidth + 70 + 'px')
      }
    }
  }
})()
